import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CgClose } from "react-icons/cg";

import trash from "../../../../assets/misc/trash.png";
import edit from "../../../../assets/misc/edit.svg";
import Pagination from "../../../../components/Pagination";
import { createCPDInitialValues, findDurationType, findTypeOfCpd } from "../../../../data/cpdConstants";
import { TechnologyFieldsOptions } from "../../../../data/UserInfoStepperConstants";
import CreateCPDActivitiesForm from "../CreateCPDActivitiesForm";
import { deleteCPD, getCPDById, handleLoading } from "../../../../redux/slices/atpSlice";
import moment from "moment";
import PrimaryLoader from "../../../../components/loaders/PrimaryLoader";
import eyeIcon from "../../../../assets/misc/eyeIcon.svg";
import Modal from "../../../../components/Modal";
import ReasonModal from "../ReasonModal";

function Rejected({ data, handlePagination, refreshTableData, pageLimit, currentPage }) {
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(createCPDInitialValues);
    const [loading, setLoading] = useState(false);
    const { current_page, total_pages } = useSelector((state) => state.atp.data);
    const modalRef = useRef();
    const dispatch = useDispatch();
    const [viewReasonModal, setViewReasonModal] = useState(false);
    const [reason, setReason] = useState("");
    const [techFieldAdd, setTechFieldShow] = useState(false);

    const handleModal = (isEdit = false) => {
        setShowModal((prev) => !prev);
        setTechFieldShow(isEdit); // Set techFieldAdd based on isEdit
    };

    const openModal = (reason) => {
        setReason(reason);
        setViewReasonModal(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setViewReasonModal(false);
        document.body.style.overflow = "auto";
    };

    const handleDeleteClick = (id) => {
        dispatch(handleLoading(true));
        dispatch(deleteCPD(id)).then(() => {
            dispatch(handleLoading(false));
            refreshTableData();
        });
    };

    const handleEditClick = (id) => {
        setLoading(true);
        dispatch(getCPDById(id)).then((response) => {
            handleModal(true); // Pass true to open the modal for edit
            setTechFieldShow(true);
            setLoading(false);
            setInitialValues({
                ...response?.payload,
                date_time: response?.payload?.date_time ? moment(response?.payload?.date_time).format("DD/MM/YYYY HH:mm A") : null,
                files: response?.payload?.attachment?.length > 0 ? response?.payload?.attachment[0] : [],
                // techFieldAdd:techFieldAdd,
            });
        });
    };
    return (
        <div>
            {showModal && (
                <div className="Add_form manuallyform_popup">
                    <div className={`modal custom-popup-overlay ${showModal ? "show" : ""}`}>
                        <div className="modal-content custom-popup-add" ref={modalRef}>
                            <div className="d-flex align-items-center justify-content-between">
                                <h2>CPD Activity</h2>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent event propagation to parent
                                        handleModal(); // Close the modal
                                    }}
                                    className="croseicn"
                                    style={{ cursor: "pointer" }}
                                >
                                    <CgClose
                                        style={{
                                            color: "#D1D5DB",
                                            height: "30px",
                                            width: "30px",
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="after-line-tittle"></div>
                            <div>
                                <CreateCPDActivitiesForm
                                    closeModal={handleModal}
                                    initialValues={initialValues}
                                    techFieldAdd={techFieldAdd}
                                    setTechFieldShow={setTechFieldShow}
                                    refreshTableData={refreshTableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}{" "}
            <div>
                <div className="tabdiv accordion-body-cpd">
                    <table className="table_layout">
                        <thead>
                            <tr className="">
                                <th className="">No.</th>
                                <th className="">Title</th>
                                <th className="">Duration</th>
                                <th className="">Category </th>
                                <th className="">Field</th>
                                <th className="">Location</th>
                                <th className="">Action</th>
                                <th className="">Feedback/Reason</th>
                            </tr>
                        </thead>
                        <div className="bordertop"></div>

                        {loading ? (
                            <tbody>
                                <tr>
                                    <td colSpan={6} className="text-decoration-none text-center">
                                        <PrimaryLoader />
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <>
                                {data?.length > 0 ? (
                                    <tbody className="">
                                        {data?.map((ele, index) => {
                                            const techFieldDisplay = TechnologyFieldsOptions.filter((option) => ele?.tech_field?.includes(String(option?.value))).map((option) => (
                                                <div key={option.value}>{option.label}</div>
                                            ));
                                            return (
                                                <tr className="list-view-line-before" key={ele?.id}>
                                                    <td className="text-decoration-none text-black">{(currentPage - 1) * pageLimit + index + 1}</td>
                                                    <td className="text-decoration-none text-black">{ele?.title}</td>
                                                    <td>
                                                        {ele?.duration_time} {findDurationType(ele?.duration_type)}
                                                    </td>
                                                    <td>{findTypeOfCpd(ele?.type_of_cpd)}</td>
                                                    <td> {techFieldDisplay}</td>
                                                    <td>{ele?.location}</td>
                                                    <td>
                                                        <div className="d-flex gap-3">
                                                            <img className="cursor-pointer" src={edit} style={{ height: "20.12px" }} onClick={() => handleEditClick(ele?.id)} />
                                                            <img className="cursor-pointer" src={trash} alt="Delete" onClick={() => handleDeleteClick(ele?.id)} />
                                                        </div>
                                                    </td>
                                                    <td className="d-flex justify-content-center align-items-center pt-5">
                                                        <img
                                                            className="cursor-pointer"
                                                            src={eyeIcon}
                                                            alt="Eye"
                                                            // onClick={() => {
                                                            //   { handleEditClick && handleEditClick(item?.id) };
                                                            //   setDisabled(true);
                                                            //   { handleViewClick && handleViewClick(item?.id) };
                                                            // }}
                                                            onClick={() => openModal(ele?.reason)}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan={6} className="text-decoration-none text-center">
                                                No Data Available
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </>
                        )}
                    </table>
                </div>
                <Pagination currentPage={current_page} totalPages={total_pages} setCurrentPage={handlePagination} />
                {viewReasonModal && (
                    <Modal closeModal={closeModal} modalRef={modalRef} showModal={viewReasonModal} modalTitle="Reason For Rejection">
                        <ReasonModal closeModal={closeModal} reason={reason} />
                    </Modal>
                )}
            </div>
        </div>
    );
}

export default Rejected;
